import logo from '../assets/simple-workout-timer-64.png';

function Header() {
  return (
    <header className="flex gap-4 px-4 py-3 text-center text-2xl text-slate-500 border-b border-red-500 pb-2">
      <img src={logo} alt="Simple Workout Timer" className="w-8 h-8" />
      <h1>Simple Workout Timer</h1>
    </header>
  );
}

export default Header;
